import { fetchAccessToken } from "@origin-digital/event-dispatcher";
import { DecodedJwt, decodeJwt } from "@origin-digital/origin-auth";

import { config } from "../config";

type DecodedJwtWithBankend = DecodedJwt & {
  payload: {
    "https://originenergy.com.au/backends"?: string[];
    "https://originenergy.com.au/masqueradeId"?: string;
    "https://originenergy.com.au/userType"?: string;
    "https://originenergy.com.au/trackingId"?: string;
  };
};

export type JWTClaims = {
  sub: string | undefined;
  customerType: string | undefined;
  backends: string[] | undefined;
  masqueradeId: string | undefined;
  userType: string | undefined;
  trackingId: string | undefined;
};

export const getJwtToken = async () => {
  const jwt = await fetchAccessToken({
    environment: config.env,
  });
  return jwt;
};

export const getUserUid = (jwt: DecodedJwt): string | undefined => {
  const {
    payload: { sub = "" },
  } = jwt;
  return sub ? sub.split("|").pop() : undefined;
};

export const isSameUser = (jwtA?: DecodedJwt, jwtB?: DecodedJwt): boolean => {
  if (!jwtA || !jwtB) return false;
  return getUserUid(jwtA) === getUserUid(jwtB);
};

export const decodeJwtWithBackend = (
  accessToken: string
): DecodedJwtWithBankend => {
  return decodeJwt(accessToken) as DecodedJwtWithBankend;
};

export const getJwtClaims = (accessToken: string | undefined): JWTClaims => {
  if (!accessToken) {
    return {
      sub: undefined,
      backends: undefined,
      customerType: undefined,
      masqueradeId: undefined,
      userType: undefined,
      trackingId: undefined,
    };
  }

  const jwt = decodeJwtWithBackend(accessToken);
  const sub = jwt.payload.sub;
  const backends = jwt.payload["https://originenergy.com.au/backends"];
  const customerType = jwt.payload["https://originenergy.com.au/customerType"];
  const masqueradeId = jwt.payload["https://originenergy.com.au/masqueradeId"];
  const userType = jwt.payload["https://originenergy.com.au/userType"];
  const trackingId = jwt.payload["https://originenergy.com.au/trackingId"];

  return {
    sub,
    backends,
    customerType,
    masqueradeId,
    userType,
    trackingId,
  };
};

export const mapJwt = (jwt: any): JWTClaims => ({
  sub: jwt.sub,
  backends: jwt["https://originenergy.com.au/backends"],
  customerType: jwt["https://originenergy.com.au/customerType"],
  masqueradeId: jwt["https://originenergy.com.au/masqueradeId"],
  userType: jwt["https://originenergy.com.au/userType"],
  trackingId: jwt["https://originenergy.com.au/trackingId"],
});
